import clsx from 'clsx';

import { PartnersFieldsFragment } from 'api/graphql-types';
import { Typography } from 'components/typography';
import { NextLink } from 'components/next-link';
import Image from 'components/image';

import styles from './partners.module.scss';

export interface IPartnersProps {
	module: PartnersFieldsFragment;
}

export const Partners = ({ module }: IPartnersProps): React.JSX.Element => {
	const { heading, logos, defaultModuleOptions } = module;
	const spaceBetweenStyles = logos && logos.length > 3 && styles.spaceBetween;
	const lightStyles = defaultModuleOptions?.extendedBackgroundColor === 'darkblue' && styles.light;

	return (
		<div className={clsx(styles.partners, lightStyles)}>
			{heading?.value && (
				<Typography tag={heading.type || 'h2'} variant="h3">
					{heading.value}
				</Typography>
			)}

			{logos && (
				<div className={clsx(styles.logoList, spaceBetweenStyles)}>
					{logos.map(
						(logo) =>
							logo?.icon &&
							logo.icon.data?.attributes?.url && (
								<NextLink key={logo.id} href={logo.href.url}>
									<Image
										attributes={logo.icon.data?.attributes}
										imageSize="thumbnail"
										fallbackAlt={logo.title}
										width={166}
										height={72}
									/>
								</NextLink>
							)
					)}
				</div>
			)}
		</div>
	);
};

export default Partners;
